// extracted by mini-css-extract-plugin
export default {"removeFieldButton":"webpack-system-elements-DynamicFields-RemoveFieldButton-RemoveFieldButton-module__removeFieldButton"};